export default __webpack_public_path__ + "99fab71.png";